import { StatusBadgeProps } from "../../components/visuals/StatusBadge";
import {
  EngagementType,
  Momentum,
  MomentumDisplay,
} from "../../models/stewardshipModels";
import governance from "../../assets/svg/governance_circle.svg";
import governanceDisabled from "../../assets/svg/governance_circle_disabled.svg";
import social from "../../assets/svg/social_circle.svg";
import socialDisabled from "../../assets/svg/social_circle_disabled.svg";
import environmental from "../../assets/svg/environmental_circle.svg";
import environmentalDisabled from "../../assets/svg/environmental_circle_disabled.svg";
import strategy from "../../assets/svg/strategy_circle.svg";
import strategyDisabled from "../../assets/svg/strategy_circle_disabled.svg";

import { graphPaletteV2, statusBadgeColors } from "../../styles";
import { BadgeStatus } from "../../enums/Status";

export const ENGAGEMENT_RECORD_ID_PARAM = "engagementRecordId";

export const ESG_ENGAGEMENT_THEMES: Record<EngagementType, number[]> = {
  [EngagementType.StrategyRiskCommunication]: [7, 13],

  [EngagementType.Governance]: [16],

  [EngagementType.Social]: [5, 8, 10],

  [EngagementType.Environmental]: [7, 13],
};

export const MOMENTUM_DISPLAY_LIST: {
  key: Momentum;
  value: MomentumDisplay;
}[] = [
  { key: Momentum.STALLING, value: MomentumDisplay.STALLING },
  { key: Momentum.PROGRESSING, value: MomentumDisplay.PROGRESSING },
  { key: Momentum.UNKNOWN, value: MomentumDisplay.UNKNOWN },
];

export const ENGAGEMENT_MOMENTUM_BADGES: StatusBadgeProps[] = [
  { status: "Planned", customText: MomentumDisplay.UNKNOWN },
  { status: "Stuck", customText: MomentumDisplay.STALLING },
  {
    status: "In progress",
    customText: MomentumDisplay.PROGRESSING,
  },
];

export const ENGAGEMENT_SECTION = "engagement";
export const TIMELINE_SECTION = "engagement-timeline";

export const ENGAGEMENT_META_THEME_IMAGES: Record<
  EngagementType,
  {
    logo: string;
    bg: string;
    disabledLogo?: string;
    textBadgeColor?: string;
    textBadgeBg?: string;
  }
> = {
  [EngagementType.StrategyRiskCommunication]: {
    logo: strategy,
    bg: graphPaletteV2[0],
    disabledLogo: strategyDisabled,
    textBadgeColor: statusBadgeColors[BadgeStatus.IN_PROGRESS].text,
    textBadgeBg: statusBadgeColors[BadgeStatus.IN_PROGRESS].bg,
  },
  [EngagementType.Governance]: {
    logo: governance,
    bg: graphPaletteV2[1],
    disabledLogo: governanceDisabled,
    textBadgeColor: statusBadgeColors[BadgeStatus.IN_PROGRESS].text,
    textBadgeBg: statusBadgeColors[BadgeStatus.IN_PROGRESS].bg,
  },
  [EngagementType.Social]: {
    logo: social,
    bg: graphPaletteV2[2],
    disabledLogo: socialDisabled,
    textBadgeColor: statusBadgeColors[BadgeStatus.WARNING].text,
    textBadgeBg: statusBadgeColors[BadgeStatus.WARNING].bg,
  },
  [EngagementType.Environmental]: {
    logo: environmental,
    bg: graphPaletteV2[3],
    disabledLogo: environmentalDisabled,
    textBadgeColor: statusBadgeColors[BadgeStatus.COMPLETE].text,
    textBadgeBg: statusBadgeColors[BadgeStatus.COMPLETE].bg,
  },
};
